import React, { useEffect, useState } from "react";
// import DBFetch from "../../utils/dbFetch";
// import video from '../../assets/videos/videoHome.mp4';
import BackgroundVideo from '../../components/elements/BackgroundVideo';



export default function Top() {
  const [ video, setVideo ] = useState(null);

  useEffect(() => {
    const randomNb = ((max, min) => {
      let randomNum = Math.random() * (max - min) + min;
      return Math.floor(randomNum);

    });
    randomNb && setVideo(require(`../../assets/videos/videoHome${ randomNb(1, 3) }.mp4`).default);
  });
   // let url = process.env.REACT_APP_API + "pages?slug=couverture&_embed";
    // let page = DBFetch(url);
   // const images = [photo1, photo2];
    return (
        <BackgroundVideo autoplay loop video={ video ? video  : null }>
            <h1>
                <span className="title">Rapport d'activité</span><span className="date">2020</span>
            </h1>
        </BackgroundVideo>

    );
}
